import { render, staticRenderFns } from "./SolicitacaoListagemGeral.vue?vue&type=template&id=3a4e456b&scoped=true"
import script from "./SolicitacaoListagemGeral.vue?vue&type=script&lang=js"
export * from "./SolicitacaoListagemGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4e456b",
  null
  
)

export default component.exports